import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs/Subject';
import {Alert, AlertType} from '../model/alert';
import 'rxjs/add/operator/filter';

@Injectable()
export class AlertService {

  private subject = new Subject<Alert>();
  private keepAfterRouteChange = false;

  constructor(private router: Router) {
    // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          // clear alert messages
          this.clear();
        }
      }
    });
  }

  // subscribe to alerts
  getAlert(alertId?: string): Observable<any> {
    return this.subject.asObservable().filter((x: Alert) => x && x.alertId === alertId);
  }

  success(message: string, alertId: any) {
    this.alert(new Alert({message, type: AlertType.Success, alertId}));
  }

  error(message: string, alertId: any) {
    this.alert(new Alert({message, type: AlertType.Error, alertId}));
    // console.log(message)
  }

  info(message: string, alertId: any) {
    this.alert(new Alert({message, type: AlertType.Info, alertId}));
  }

  warn(message: string, alertId: any) {
    this.alert(new Alert({message, type: AlertType.Warning, alertId}));
  }

  // main alert method
  alert(alert: Alert) {
    this.keepAfterRouteChange = alert.keepAfterRouteChange;
    this.subject.next(alert);
  }

  // clear alerts
  clear() {
    // clear alerts
    this.subject.next();
  }

  clearById(alertId?: string) {
    this.clear();
    this.subject.next(new Alert({alertId}));
  }

}



// WEBPACK FOOTER //
// ./src/app/service/alert.service.ts